import { render } from "./DailyReport.vue?vue&type=template&id=04b4c1f1&scoped=true"
import script from "./DailyReport.vue?vue&type=script&lang=js"
export * from "./DailyReport.vue?vue&type=script&lang=js"

import "./DailyReport.vue?vue&type=style&index=0&id=04b4c1f1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-04b4c1f1"

export default script